import { useSetAtom } from "jotai";
import { draftReturnAtomFamily } from "../atoms/draft-return.atom";
import { addLineItem, createDraft } from "../lib/draft.lib";
import type { DraftLineItem } from "../types";

export function useAddLineItem(orderId: string, shopId: string) {
  const setDraft = useSetAtom(draftReturnAtomFamily(orderId));

  return (item: DraftLineItem) => {
    setDraft((draft) => addLineItem(draft ?? createDraft(orderId, shopId), item));
  };
}
